type ButtonProps = {
  title: string;
  icon?: JSX.Element;
  onClick: () => void;
  disabled?: boolean;
};

// We call this button Button2 until it is implemented in design system and we know the correct name
const PrimaryButton = ({ title, onClick, disabled, icon }: ButtonProps) => {
  return (
    <button
      className="px-4 py-2 text-white rounded shadow-sm bg-primary-blue hover:bg-primary-washed disabled:cursor-not-allowed disabled:bg-primary-medium-dark focus:shadow-outline focus:outline-hidden"
      onClick={onClick}
      disabled={disabled}
    >
      <div className="flex flex-row">
        {icon ? <span className="my-auto mr-2">{icon}</span> : null}
        <span className="mx-auto">{title}</span>
      </div>
    </button>
  );
};

const SecondaryButton = ({ title, onClick, disabled, icon }: ButtonProps) => {
  return (
    <button
      className="text-gray-800 border-primary-blue bg-[#C0C0C0] shadow-sm hover:bg-[#979797] disabled:cursor-not-allowed disabled:bg-primary-medium-dark focus:shadow-outline outline-secondary focus:outline-hidden py-2 px-4 w-full h-full rounded"
      onClick={onClick}
      disabled={disabled}
    >
      <div className="flex flex-row justify-center">
        <span className="text-l">{title} </span>
        {icon ? (
          <div className="flex items-center ml-2 ">
            {" "}
            <span className="">{icon}</span>
          </div>
        ) : null}
      </div>
    </button>
  );
};

export const OrangeButton = ({ title, onClick, disabled }: ButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="h-full px-4 py-2 text-lg font-bold text-white duration-150 rounded-xl w-fit whitespace-nowrap hover:scale-105 disabled:cursor-not-allowed disabled:bg-primary-medium-dark"
      style={{
        background:
          !disabled &&
          "linear-gradient(294.45deg, #EF8241 25.98%, #FFA02E 69.8%)",
        boxShadow:
          "0px 0px 8px #FF4000, 0px 0px 8px #FF4000, -5px 5px 4px rgba(0, 0, 0, 0.5)",
      }}
    >
      {title}
    </button>
  );
};

export { PrimaryButton, SecondaryButton };
